import KitFadeView from '@omni/kit/components/KitFadeView';
import { useTranslation } from '@omni/kit/hooks/useTranslation';
import React, { ReactElement } from 'react';
import { ViewStyle } from 'react-native';

import PlayerButton from './PlayerButton';

export default function DismissControl({
  isVisible = true,
  style,
  onPress,
}: {
  isVisible?: boolean;
  style?: ViewStyle;
  onPress?: () => void;
}): ReactElement {
  const { t } = useTranslation('media');

  return (
    <KitFadeView show={isVisible} style={style}>
      <PlayerButton
        icon='chevron-down'
        onPress={onPress}
        frameless
        tooltipProps={{
          position: 'bottom center',
          label: t('dismiss'),
        }}
      />
    </KitFadeView>
  );
}
